import React from 'react';
import { Dialog, DialogContent, DialogTitle, IconButton } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';

interface Provider {
    id: number;
    providerName: string;
    groupAffiliation: string;
    address: string;
    phone: string;
    tin: string;
    provId: string;
    acknowledgement: boolean;
    mpnParticipation: { name: string; ids: string[] }[];
}

interface AcknowledgementModalProps {
    provider: Provider;
    onClose: () => void;
}

const AcknowledgementModal: React.FC<AcknowledgementModalProps> = ({ provider, onClose }) => {
    return (
        <Dialog
            open={true}
            onClose={onClose}
            maxWidth={false}
            fullWidth
            PaperProps={{
                className: 'acknowledgement-modal-paper'
            }}
        >
            <DialogTitle>
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                    <span>MPN Acknowledgement Form</span>
                    <IconButton onClick={onClose} size="small">
                        <CloseIcon />
                    </IconButton>
                </div>
            </DialogTitle>
            
            <DialogContent>
                <div className="acknowledgement-form-container">
                    <div className="acknowledgement-title">
                        Coventry Workers Compensation Services<br />
                        Medical Provider Network (MPN) Acknowledgement Form
                    </div>
                    <div className="acknowledgement-date">
                        {new Date().toLocaleDateString(undefined, { year: 'numeric', month: 'long', day: 'numeric' })}
                    </div>
                    <div className="acknowledgement-provider-details">
                        {provider.providerName}<br />
                        {provider.groupAffiliation}<br />
                        {provider.address.split('\n').map((line: string, i: number) => <div key={i}>{line}</div>)}
                        {provider.phone && <div>Ph: {provider.phone}</div>}
                        {provider.tin && <div>Tax ID: {provider.tin}</div>}
                        {provider.provId && <div>Prov ID: {provider.provId}</div>}
                    </div>
                    <div className="acknowledgement-section">
                        Today you are participating in one or more of the Coventry Workers' Compensation Medical Provider Networks. The MPN regulations are found in Title 8, California Code of Regulations, sections 9767.1 - 9767.19 (MPN regulations).                    </div>
                    <div className="acknowledgement-section-bold">
                        Current MPN Participation(s):
                    </div>
                    
                    <table className="acknowledgement-table bordered-table">
                        <thead>
                            <tr>
                                <th>MPN Name</th>
                                <th>DWC Approved MPN ID #</th>
                            </tr>
                        </thead>
                        <tbody>
                            {provider.mpnParticipation
                                ?.slice()
                                .sort((a, b) => a.name.localeCompare(b.name))
                                .map((mpn: { name: string; ids: string[] }, idx: number) => (
                                    <tr key={idx}>
                                        <td className="ack-table-cell-mpn-name">{mpn.name}</td>
                                        <td className="ack-table-cell-mpn-id">{mpn.ids && mpn.ids.length > 0 ? mpn.ids.join(', ') : ''}</td>
                                    </tr>
                                ))}
                        </tbody>
                    </table>
                    <div className="acknowledgement-footer">
                        If you want to discontinue any of your specific MPN participations listed above, please e-mail <a href="mailto:DemoUpdates@cvty.us.com">DemoUpdates@cvty.us.com</a> or contact Coventry Provider Relations at 1-800-937-6824.
                    </div>
                </div>
            </DialogContent>
        </Dialog>
    );
};

export default AcknowledgementModal;